import { Icon } from '@iconify/react';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { config } from '../../../config';
import ResourceManager, { ResourceColumn, ResourceField } from '../../admin/components/ResourceManager';
import { useAuth } from '../../auth/auth.context';
import { checklistTemplatesApi } from '../siteVisits.api';

const columns: ResourceColumn[] = [
  { id: 'purpose', dataKey: 'purpose', label: 'Purpose', align: 'left', sortable: true },
  { id: 'sortOrder', dataKey: 'sortOrder', label: 'Order', align: 'center', sortable: true },
  { id: 'title', dataKey: 'title', label: 'Checklist item', align: 'left', sortable: true },
  { id: 'hint', dataKey: 'hint', label: 'What to check', align: 'left' },
  {
    id: 'active',
    dataKey: 'active',
    label: 'Active',
    align: 'center',
    renderCell: (value: boolean) => <Chip size='small' color={value ? 'success' : 'default'} label={value ? 'Yes' : 'No'} />,
  },
];

const fields: ResourceField[] = [
  {
    name: 'purpose',
    label: 'Purpose',
    required: true,
    helperText: 'Items with the same purpose make one checklist, e.g. "Slab / beam before casting"',
  },
  { name: 'title', label: 'Checklist item', required: true },
  { name: 'hint', label: 'What to check (shown to the engineer)', type: 'textarea' },
  { name: 'sortOrder', label: 'Order', type: 'number', defaultValue: 10 },
  { name: 'active', label: 'Active', type: 'boolean' },
];

/**
 * The checklists a visit's purpose fills in. Scheduling a visit picks the purpose and copies
 * its active items onto the visit, so a change here affects visits scheduled afterwards only.
 * Analysts can read them; only an admin edits.
 */
export default function SiteVisitChecklistsPage() {
  const navigate = useNavigate();
  const { role } = useAuth();
  const isAdmin = role === config.USER_ROLES.ADMIN;
  return (
    <Stack gap={2}>
      <Stack direction='row'>
        <Button startIcon={<Icon icon='mdi:arrow-left' />} onClick={() => navigate('/site-visits')}>Site visits</Button>
      </Stack>
      <ResourceManager
        title='SITE VISIT CHECKLISTS'
        entityName='Checklist item'
        client={checklistTemplatesApi}
        columns={columns}
        fields={fields}
        canCreate={isAdmin}
        canEdit={isAdmin}
        canDelete={isAdmin}
      />
    </Stack>
  );
}
